import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowbackFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.603 4.82a1.15 1.15 0 0 1 .045 1.626L9.395 12l5.253 5.554a1.15 1.15 0 0 1-1.67 1.58l-6-6.344a1.15 1.15 0 0 1 0-1.58l6-6.344a1.15 1.15 0 0 1 1.625-.045",
    clipRule: "evenodd"
  }));
}
var IcArrowbackFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowbackFill));

export { IcArrowbackFill as I };
